import { Injectable } from '@angular/core';
import { commonClass } from '../models/commonClass';
import { RoleAccessService } from '../services/roleAccess.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

const TOKEN_KEY = 'auth-code';
const USER_ID = 'user-id';
const USER_DATA = 'user-data';
const SUBPROJECTID = 'subproject-id';
const FRANCHISELIST = 'franchiseList';
const NAVBAR_SESSION = 'navbar-data';
const NAVBAR_SESSIOND2 = 'navbard2-data';
const NAVBAR_SESSIOND3 = 'navbard3-data';
const ATAGLANCE_SESSION = 'ataglance-data';
const REMEMBER_ME = 'remember-me'
const USER_LOGIN_DETAILS = 'login-details'
const AUTHCODE_REMEMBER_ME = 'remember-auth-code';
const FILTER_DATA = "filter-data";
const PHASE_BUTTON = "phase-button";
const PRIORITY_BUTTONS = "priority-button";
const STATUS_BUTTON = "status-button";
const DETAIL_SCREEN_DATA = "detail-screen-data";
const LOGINDETAILS = 'login'

const COMINGFROMCAPTURE = "comingfromcapture";
const GALLARY_DATA = "gallary-data";
const REPORTS_DATA = "reports-data";
const NEWS_DATA = "news-data";
const UPCOMING_EVENTS_DATA = "upcomimg-data";
const KITS_KIQS_DATA = "kits-kiqs-data";
const PAST_EVENTS_DATA = "past-events-data";
const GROUP_DETAILS = "group-details-data"

const CONGRESS_SCREEN_DATA = "congress-screen-data";
// const DETAIL_SCREEN_DATA = "detail-screen-data";
const USERROLE = "user-role";
const ISADMIN = "isAdmin";
const GLANCEPREFERENCE = "glancepreference";
const CLINICALPREFERENCE = "clinicalpreference";
const PRODUCTPROFILE = "productprofile";
const TIMELINE = "Timeline";

const BASEDATA = "basedata";
@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private roleService: RoleAccessService, private router: Router) { }

  public setRememberMe(status: any, authCode: string) {
    localStorage.removeItem(REMEMBER_ME);
    localStorage.removeItem(USER_LOGIN_DETAILS);
    localStorage.removeItem(AUTHCODE_REMEMBER_ME);
    localStorage.setItem(REMEMBER_ME, status.rememberMe);
    if (status.rememberMe) {
      localStorage.setItem(USER_LOGIN_DETAILS, JSON.stringify(status));
      localStorage.setItem(AUTHCODE_REMEMBER_ME, authCode);
    } else {

    }
  }

  public getRememberMe() {
    return localStorage.getItem(REMEMBER_ME);
  }

  public getRememberMeDetails() {

    return JSON.parse(localStorage.getItem(USER_LOGIN_DETAILS));
  }
  public setLoginData(user: any, userData: any) {
    localStorage.removeItem(LOGINDETAILS);
    if (user)
      localStorage.setItem(LOGINDETAILS, JSON.stringify(user))
    this.setUser(userData);
    this.setToken(userData['AUTH_CODE']);
    if (user)
      this.setRememberMe(user, userData['AUTH_CODE']);
    this.roleService.setRoleData(userData)
  }

  public getLoginData(): any {
    return JSON.parse(localStorage.getItem(LOGINDETAILS));
  }
  public setUserRole(role: string) {
    localStorage.removeItem(USERROLE);
    localStorage.setItem(USERROLE, role);
  }
  public setAdminRole(role: string) {
    if (role == "1") {
      localStorage.setItem(ISADMIN, 'true');
    }
    else {
      localStorage.setItem(ISADMIN, 'false');
    }
  }
  public getAdminRole() {
    if (localStorage.getItem(ISADMIN) == "true") {
      return true;
    }
    else {
      return false;
    }
  }
  public getUserRole() {
    return localStorage.getItem(USERROLE);
  }
  public setLoginDataOnchangePassword(user: any) {
    let loginData = this.getRememberMeDetails()
    if (loginData) {
      loginData.password = user.NEW_PASSWORD
      localStorage.removeItem(USER_LOGIN_DETAILS);
      localStorage.setItem(USER_LOGIN_DETAILS, JSON.stringify(loginData));
    }
  }

  // getavtiveNavElement():any{
  //     return this.avtiveNavElement;
  // }


  signout() {

    this.removeAllFilterData();
    //Add the storage we want to remove
    localStorage.removeItem("ButtonListGlance");
    localStorage.removeItem("adminCorner");

    //  localStorage.clear()
    localStorage.removeItem(REMEMBER_ME);
    localStorage.removeItem(USER_LOGIN_DETAILS);
    localStorage.removeItem(AUTHCODE_REMEMBER_ME);
    this.removeAllDashboardData()
    localStorage.removeItem(LOGINDETAILS);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_DATA);
    localStorage.removeItem(FRANCHISELIST);
    localStorage.removeItem(SUBPROJECTID);
    localStorage.removeItem(DETAIL_SCREEN_DATA);
    localStorage.removeItem(GROUP_DETAILS);

    localStorage.removeItem(BASEDATA);
    localStorage.removeItem("myCliniData");
    localStorage.removeItem("phaseButtons");
    localStorage.removeItem("ButtonListD3");
    localStorage.removeItem("myProductProData");
    localStorage.removeItem(PRODUCTPROFILE)

    const regex = new RegExp(`^${NAVBAR_SESSIOND3}\\d+$`); // Dynamic regex to match prefix followed by digits
    const regexAtaGlance = new RegExp(`^${ATAGLANCE_SESSION}\\d+$`); // Dynamic regex to match prefix followed by digits
    const regexNumber = /^\d+$/;// Dynamic regex to match prefix followed by digits

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (regex.test(key)) { // Check if the key matches the dynamic pattern
        localStorage.removeItem(key);
        i--; // Adjust index after removing item
      }
      if (regexNumber.test(key)) { // Check if the key matches the dynamic pattern
        localStorage.removeItem(key);
        i--; // Adjust index after removing item
      }
      if (regexAtaGlance.test(key)) { // Check if the key matches the dynamic pattern
        localStorage.removeItem(key);
        i--; // Adjust index after removing item
      }
    }


  }
  clearall() {
    localStorage.clear()
  }

  public setToken(token: string) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token)
  }

  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  public setUser(user: any) {
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_DATA)
    localStorage.setItem(USER_ID, user.USERID)
    localStorage.setItem(USER_DATA, JSON.stringify(user))
    this.setSubprojectID(user['SUBPROJECTID']);
    this.setUserRole(user['ROLE']);
    this.setAdminRole(user['ADMINROLE']);
  }
  public setSubprojectID(id: any) {
    localStorage.removeItem(SUBPROJECTID)
    localStorage.setItem(SUBPROJECTID, id)
  }

  public getSubprojectID(): string {
    return localStorage.getItem(SUBPROJECTID)
  }

  public setFranchiseList(list: any) {
    localStorage.removeItem(FRANCHISELIST)
    localStorage.setItem(FRANCHISELIST, JSON.stringify(list))
  }

  public getFranchiseList() {
    return JSON.parse(localStorage.getItem(FRANCHISELIST))
  }

  public getUserData(): any {
    const raw = localStorage.getItem(USER_DATA);

    if (!raw || raw === "undefined" || raw === "null") {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (e) {
      console.error("Invalid USER_DATA JSON:", raw);
      this.signout();
      return null;
    }
  }

  public setUserData(user: any): any {
    localStorage.setItem(USER_DATA, JSON.stringify(user))
  }
  public setSMSData(state) {
    var user = this.getUserData();
    user["SMS"] = state == true ? 1 : 0;
    this.setUserData(user)
  }
  public setSMSDataNew(state) {
    var user = this.getUserData();
    user["SMS"] = state == "true" ? "0" : "1";
    this.setUserData(user)
  }
  public setDefaultData(state) {
    var user = this.getUserData();
    user["MYDEFALULT"] = state;
    this.setUserData(user)
  }
  public getUserId(): string {
    return localStorage.getItem(USER_ID);
  }

  public setNavBar(data: any) {
    localStorage.removeItem(NAVBAR_SESSION)
    localStorage.setItem(NAVBAR_SESSION, JSON.stringify(data));
  }
  public geNavBar(): any {
    return JSON.parse(localStorage.getItem(NAVBAR_SESSION));
  }
  public setD2NavBar(data: any) {
    localStorage.removeItem(NAVBAR_SESSIOND2)
    localStorage.setItem(NAVBAR_SESSIOND2, JSON.stringify(data));
  }
  public getD2NavBar(): any {
    if (localStorage.getItem(NAVBAR_SESSIOND2)) {
      return JSON.parse(localStorage.getItem(NAVBAR_SESSIOND2));
    }
    else {
      localStorage.setItem(NAVBAR_SESSIOND2, JSON.stringify(commonClass.Dashboard2DefaultButtonList));
      return commonClass.Dashboard2DefaultButtonList;
    }
  }
  public setD3NavBar(data: any) {
    if (localStorage.getItem(NAVBAR_SESSIOND3 + this.getUserId())) {
      localStorage.removeItem(NAVBAR_SESSIOND3 + this.getUserId())
    } else
      localStorage.removeItem(NAVBAR_SESSIOND3)
    localStorage.setItem(NAVBAR_SESSIOND3 + this.getUserId(), JSON.stringify(data));
  }
  public getD3NavBar(): any {
    if (localStorage.getItem(NAVBAR_SESSIOND3 + this.getUserId())) {
      return JSON.parse(localStorage.getItem(NAVBAR_SESSIOND3 + this.getUserId()));
    }
    else {
      localStorage.setItem(NAVBAR_SESSIOND3 + this.getUserId(), JSON.stringify(commonClass.Dashboard3DefaultButtonList));
      return commonClass.Dashboard3DefaultButtonList;
    }
  }

  public setataglanceNavBar(data: any) {
    if (localStorage.getItem(ATAGLANCE_SESSION + this.getUserId())) {
      localStorage.removeItem(ATAGLANCE_SESSION + this.getUserId())
    } else
      localStorage.removeItem(ATAGLANCE_SESSION)
    localStorage.setItem(ATAGLANCE_SESSION + this.getUserId(), JSON.stringify(data));
  }
  public getataglanceNavBar(): any {
    if (localStorage.getItem(ATAGLANCE_SESSION + this.getUserId())) {
      return JSON.parse(localStorage.getItem(ATAGLANCE_SESSION + this.getUserId()));
    }
    else {
      localStorage.setItem(ATAGLANCE_SESSION + this.getUserId(), JSON.stringify(commonClass.atAGlanceButtonList));
      return commonClass.atAGlanceButtonList;
    }
  }

  public setGlancePreference(preference) {
    localStorage.removeItem(GLANCEPREFERENCE)
    localStorage.setItem(GLANCEPREFERENCE, preference)
  }
  public getGlancePreference() {
    return localStorage.getItem(GLANCEPREFERENCE)
  }
  public setClinicalPreference(preference) {
    localStorage.removeItem(CLINICALPREFERENCE)
    localStorage.setItem(CLINICALPREFERENCE, preference)
  }
  public getClinicalPreference() {
    return localStorage.getItem(CLINICALPREFERENCE)
  }
  public setProductProfilePreference(preference) {
    localStorage.removeItem(PRODUCTPROFILE)
    localStorage.setItem(PRODUCTPROFILE, preference)
  }
  public getProductProfilePreference() {
    return localStorage.getItem(PRODUCTPROFILE)
  }
  public setTimelinePreference(preference) {
    localStorage.removeItem(TIMELINE)
    localStorage.setItem(TIMELINE, preference)
  }
  public getTimelinePreference() {
    return localStorage.getItem(TIMELINE)
  }

  public setFilterData(filterdata: any, phaseButtons: any, priorityButtons: any, statusButtons: any,) {
    localStorage.removeItem(FILTER_DATA)
    localStorage.removeItem(PHASE_BUTTON)
    localStorage.removeItem(PRIORITY_BUTTONS)
    localStorage.removeItem(STATUS_BUTTON)
    localStorage.setItem(FILTER_DATA, JSON.stringify(filterdata));
    localStorage.setItem(PHASE_BUTTON, JSON.stringify(phaseButtons));
    localStorage.setItem(PRIORITY_BUTTONS, JSON.stringify(priorityButtons));
    localStorage.setItem(STATUS_BUTTON, JSON.stringify(statusButtons));
  }

  public getFilterData() {
    return JSON.parse(localStorage.getItem(FILTER_DATA));
  }

  public getPhaseButton() {
    return JSON.parse(localStorage.getItem(PHASE_BUTTON));
  }

  public getPriorityButon() {
    return JSON.parse(localStorage.getItem(PRIORITY_BUTTONS));
  }

  public getStatusButton() {
    return JSON.parse(localStorage.getItem(STATUS_BUTTON));
  }

  public removeAllFilterData() {
    localStorage.removeItem(FILTER_DATA)
    localStorage.removeItem(PHASE_BUTTON)
    localStorage.removeItem(PRIORITY_BUTTONS)
    localStorage.removeItem(STATUS_BUTTON)
  }


  public setDetailsScreenData(data) {
    localStorage.removeItem(DETAIL_SCREEN_DATA);
    localStorage.setItem(DETAIL_SCREEN_DATA, JSON.stringify(data))
  }

  public getDetailsScreenData() {
    return JSON.parse(localStorage.getItem(DETAIL_SCREEN_DATA));
  }

  public setDetailsScreenDataNew(data, documentID) {
    //localStorage.removeItem(DETAIL_SCREEN_DATA);
    localStorage.setItem(documentID, JSON.stringify(data))
  }

  public getDetailsScreenDataNew(documentID) {
    return JSON.parse(localStorage.getItem(documentID));
  }


  public setGalaryData(data) {
    localStorage.removeItem(GALLARY_DATA);
    localStorage.setItem(GALLARY_DATA, JSON.stringify(data))
  }
  public getGalaryData() {
    return JSON.parse(localStorage.getItem(GALLARY_DATA));
  }

  public setBaseData(data) {
    localStorage.removeItem(BASEDATA);
    localStorage.setItem(BASEDATA, JSON.stringify(data))
  }
  public getBaseData() {
    return JSON.parse(localStorage.getItem(BASEDATA));
  }

  public isItemFromCaptureScreen() {
    if (localStorage.getItem(COMINGFROMCAPTURE)) {
      localStorage.removeItem(COMINGFROMCAPTURE)
      return true;
    }
    else {
      return false;
    }
  }
  public setItemFromCaptureScreen() {
    localStorage.setItem(COMINGFROMCAPTURE, JSON.stringify(true));
  }

  public setReportData(data) {

    localStorage.removeItem(REPORTS_DATA);
    localStorage.setItem(REPORTS_DATA, JSON.stringify(data))
  }
  public getReportData() {
    return JSON.parse(localStorage.getItem(REPORTS_DATA));
  }


  public setNewsData(data) {

    localStorage.removeItem(NEWS_DATA);
    localStorage.setItem(NEWS_DATA, JSON.stringify(data))
  }
  public getNewsData() {
    return JSON.parse(localStorage.getItem(NEWS_DATA));
  }


  public setUpcomingEventsData(data) {

    localStorage.removeItem(UPCOMING_EVENTS_DATA);
    localStorage.setItem(UPCOMING_EVENTS_DATA, JSON.stringify(data))
  }
  public getUpcomingEventsData() {
    return JSON.parse(localStorage.getItem(UPCOMING_EVENTS_DATA));
  }


  public setKitsKiqsData(data) {
    localStorage.removeItem(KITS_KIQS_DATA);
    localStorage.setItem(KITS_KIQS_DATA, JSON.stringify(data))
  }
  public getKitsKiqsData() {
    return JSON.parse(localStorage.getItem(KITS_KIQS_DATA));
  }


  public setPastEventsData(data) {
    localStorage.removeItem(PAST_EVENTS_DATA);
    localStorage.setItem(PAST_EVENTS_DATA, JSON.stringify(data))
  }
  public getPastEventsData() {
    return JSON.parse(localStorage.getItem(PAST_EVENTS_DATA));
  }


  public removeAllDashboardData() {
    localStorage.removeItem(GALLARY_DATA);
    localStorage.removeItem(REPORTS_DATA);
    localStorage.removeItem(NEWS_DATA);
    localStorage.removeItem(UPCOMING_EVENTS_DATA);
    localStorage.removeItem(KITS_KIQS_DATA);
    localStorage.removeItem(PAST_EVENTS_DATA);
  }


  public setGroupData(data) {
    localStorage.removeItem(GROUP_DETAILS);
    localStorage.setItem(GROUP_DETAILS, JSON.stringify(data))
  }
  public getGroupData() {
    return JSON.parse(localStorage.getItem(GROUP_DETAILS));
  }

  public setCongressScreenData(data) {
    localStorage.removeItem(CONGRESS_SCREEN_DATA);
    localStorage.setItem(CONGRESS_SCREEN_DATA, JSON.stringify(data))
  }

  public getCongressScreenData() {
    return JSON.parse(localStorage.getItem(CONGRESS_SCREEN_DATA));
  }

  public resetDashboardTheme() {
    localStorage.removeItem("DashboardTheme");
  }
  public setDashboardTheme(number) {
    localStorage.setItem("DashboardTheme", number);
  }
  public getDashboardTheme() {
    return localStorage.getItem("DashboardTheme");
  }
  public getThemeBaseDashboardRoute() {
    let themeNumber: string = this.getDashboardTheme();
    if (themeNumber == null) {
      return "/dashboard/d3";
    }
    //else if (themeNumber == "1") {
    //  return "/dashboard";
    //}
    //else if (themeNumber == "2") {
    //  return "/dashboard/d2";
    //}
    else if (themeNumber == "3") {
      return "/dashboard/d3";
    }
    else if (themeNumber == "4") {
      return "/dashboard/d4";
    }
    return "/dashboard/d3";
  }

  public setSubCategoryPage(term: string) {
    localStorage.setItem("subcategorypage", term);
  }
  public getSubCategoryPage() {
    return localStorage.getItem("subcategorypage");
  }
  public isEditor() {
    let currentRole = this.getUserRole();
    if (currentRole == commonClass.RoleEditorView) {
      return true;
    }
    else {
      return false;
    }
  }
  authCodeExpired() {
    Swal.fire({
      title: 'Authentication Expired',
      text: "You authentication session has been expired, Please log in again.",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
    }).then((result) => {
      if (result.isConfirmed) {
        this.signout();
        this.router.navigateByUrl("/")
      }
    });
  }
  error500() {

  }
}
